import NotifBadge from '@/core/components/NotifBadge/NotifBadge';

export default NotifBadge;
